import type { FC, HTMLAttributes, MouseEventHandler } from "react";

import { type TrackingProps, trackEvent } from "utils/amplitude";

export type TrackedDivProps = HTMLAttributes<HTMLDivElement> & TrackingProps;

/**
 * A div that tracks events when clicked.
 *
 * @param {TrackedDivProps} props - The props for the TrackedDiv component.
 * @returns {JSX.Element} The tracked div component.
 */
export const TrackedDiv: FC<TrackedDivProps> = ({
  eventName,
  eventProps = {},
  onClick,
  ...props
}) => {
  const clickHandler: MouseEventHandler<HTMLDivElement> | undefined = eventName
    ? (e) => {
        if (onClick) {
          trackEvent(eventName, { eventCategory: "Button press", ...eventProps });

          onClick(e);
        }
      }
    : onClick;

  return <div {...props} onClick={clickHandler} />;
};
